/**
 * useCredentialEventTracking Hook
 * Phase 1 Day 45 - Extract credential event tracking state
 *
 * Manages state for tracking credential lifecycle events.
 * Used by PatronCredentialsModal to show recent credential operations.
 */

import { useState } from "react";

export function useCredentialEventTracking() {
  const [lastCredentialDownload, setLastCredentialDownload] = useState(null);
  const [lastCredentialProvisioned, setLastCredentialProvisioned] =
    useState(null);
  const [lastCredentialRemoved, setLastCredentialRemoved] = useState(null);

  return {
    lastCredentialDownload,
    setLastCredentialDownload,
    lastCredentialProvisioned,
    setLastCredentialProvisioned,
    lastCredentialRemoved,
    setLastCredentialRemoved,
  };
}
